import { type SxProps, type Theme } from '@mui/material';

export const AlertStyles: SxProps<Theme> = {
  '&.error': {
    backgroundColor: '#e64033',
  },
  '&.success': {
    backgroundColor: '#53af50',
  },
  alignItems: 'center',
  borderRadius: '5px',
  color: '#fff',
  display: 'flex',
  padding: theme => `${theme.spacing(1)} ${theme.spacing(2)}`,
};

export const AlertIconStyles: SxProps<Theme> = {
  display: 'flex',
  marginRight: theme => theme.spacing(1),
};
